<template>
  <div class="space-y-1">
    <div class="flex gap-1">
      <BuilderInput
        class="min-w-0 flex-1 text-xs"
        :modelValue="search"
        placeholder="Search or enter entity ID…"
        @update:modelValue="search = $event" />
      <BuilderSelect
        v-if="filteredEntities.length"
        class="w-44 text-xs"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)">
        <option value="">Select entity…</option>
        <option v-if="unknownValue" :value="modelValue">{{ modelValue }} · saved value</option>
        <option v-for="entity in filteredEntities" :key="entity.id" :value="entity.id">
          {{ entity.name || entity.id }} · {{ entity.domain }}
        </option>
      </BuilderSelect>
    </div>
    <div v-if="search && !selectedSearchMatch" class="text-[11px] text-amber-300">
      Manual entity ID: {{ search }}
      <button type="button" class="ml-1 text-cyan-300 hover:text-cyan-200" @click="$emit('update:modelValue', search)">Use</button>
    </div>
    <div v-if="unknownValue" class="text-[11px] text-amber-300">
      Saved entity is not present in current plate metadata; it is preserved.
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import BuilderInput from '../hassbuilder/automation/BuilderInput.vue'
import BuilderSelect from '../hassbuilder/automation/BuilderSelect.vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  entities: { type: Array, default: () => [] },
})
defineEmits(['update:modelValue'])

const search = ref(props.modelValue)
watch(() => props.modelValue, value => { if (value !== search.value) search.value = value || '' })

const normalizedSearch = computed(() => search.value.trim().toLowerCase())
const filteredEntities = computed(() => props.entities.filter(entity => {
  if (!normalizedSearch.value) return true
  return `${entity.name || ''} ${entity.id || ''} ${entity.domain || ''}`.toLowerCase().includes(normalizedSearch.value)
}))
const selectedSearchMatch = computed(() => props.entities.some(entity => entity.id === search.value.trim()))
const unknownValue = computed(() => Boolean(props.modelValue) && !props.entities.some(entity => entity.id === props.modelValue))
</script>
